import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "wardogs_consent";

const ConsentBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => { if (!localStorage.getItem(KEY)) setShow(true); }, 700);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, new Date().toISOString()); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="consent-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="!fixed bottom-3 left-3 right-3 lg:left-auto lg:right-6 lg:bottom-6 lg:max-w-md z-[70] glass tactical-frame border border-[#D4A94A]/30 p-5"
        >
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 bg-[#D4A94A]/15 border border-[#D4A94A]/40 tactical-frame-sm flex items-center justify-center shrink-0">
              <Cookie className="w-5 h-5 text-[#D4A94A]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="overline mb-1">// Comms Notice</div>
              <p className="text-[13px] leading-relaxed text-[#94A3B8]">
                We use essential cookies and local storage to keep you signed in and run the site.
                No ad trackers. See our{" "}
                <Link to="/privacy" data-testid="consent-privacy-link" className="text-[#D4A94A] hover:underline">Privacy Policy</Link>.
              </p>
              <div className="flex items-center gap-2 mt-3">
                <button data-testid="consent-accept" onClick={dismiss} className="bg-[#D4A94A] hover:bg-[#E5BD60] text-black font-stencil font-black uppercase text-xs px-4 py-2 tactical-frame-sm transition-colors">Roger that</button>
                <Link to="/privacy" onClick={dismiss} data-testid="consent-learn-more" aria-label="Learn more in our Privacy Policy" className="font-stencil font-bold uppercase text-xs px-4 py-2 border border-[#2A2E3D] hover:border-[#D4A94A] tactical-frame-sm text-[#94A3B8] transition-colors">Learn more</Link>
              </div>
            </div>
            <button data-testid="consent-close" onClick={dismiss} aria-label="Dismiss" className="text-[#64748B] hover:text-[#F1F5F9] shrink-0"><X className="w-4 h-4" /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConsentBanner;
